// @generated by protoc-gen-es v2.2.3 with parameter "target=ts,import_extension=none"
// @generated from file v1/org/org_service.proto (package api.v1.org, syntax proto3)
/* eslint-disable */

import type { GenFile, GenService } from "@bufbuild/protobuf/codegenv1";
import { fileDesc, serviceDesc } from "@bufbuild/protobuf/codegenv1";
import type { EmptySchema } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_empty } from "@bufbuild/protobuf/wkt";
import { file_v1_org_org_types } from "./org_types_pb";
import type { CreateImageRequestSchema, CreateRequestSchema, CreateResponseSchema, DeleteRequestSchema, DeleteResponseSchema, FollowRequestSchema, FollowResponseSchema, GetByIdRequestSchema, GetByIdResponseSchema, GetFollowingInfoRequestSchema, GetFollowingInfoResponseSchema, GetRequestSchema, GetResponseSchema, ListCategoriesResponseSchema, ListFollowersRequestSchema, ListFollowersResponseSchema, SearchOrgsRequestSchema, SearchOrgsResponseSchema, UnfollowRequestSchema, UnfollowResponseSchema, UpdateCollaborationVisibilityRequestSchema, UpdateCollaborationVisibilityResponseSchema, UpdateRequestSchema, UpdateResponseSchema } from "./org_requests_pb";
import { file_v1_org_org_requests } from "./org_requests_pb";

/**
 * Describes the file v1/org/org_service.proto.
 */
export const file_v1_org_org_service: GenFile = /*@__PURE__*/
  fileDesc("Chh2MS9vcmcvb3JnX3NlcnZpY2UucHJvdG8SCmFwaS52MS5vcmcy8gcKCk9yZ1NlcnZpY2USPwoGQ3JlYXRlEhkuYXBpLnYxLm9yZy5DcmVhdGVSZXF1ZXN0GhouYXBpLnYxLm9yZy5DcmVhdGVSZXNwb25zZRI/CgZVcGRhdGUSGS5hcGkudjEub3JnLlVwZGF0ZVJlcXVlc3QaGi5hcGkudjEub3JnLlVwZGF0ZVJlc3BvbnNlEj8KBkRlbGV0ZRIZLmFwaS52MS5vcmcuRGVsZXRlUmVxdWVzdBoaLmFwaS52MS5vcmcuRGVsZXRlUmVzcG9uc2USNgoDR2V0EhYuYXBpLnYxLm9yZy5HZXRSZXF1ZXN0GhcuYXBpLnYxLm9yZy5HZXRSZXNwb25zZRJCCgdHZXRCeUlkEhouYXBpLnYxLm9yZy5HZXRCeUlkUmVxdWVzdBobLmFwaS52MS5vcmcuR2V0QnlJZFJlc3BvbnNlEoQBCh1VcGRhdGVDb2xsYWJvcmF0aW9uVmlzaWJpbGl0eRIwLmFwaS52MS5vcmcuVXBkYXRlQ29sbGFib3JhdGlvblZpc2liaWxpdHlSZXF1ZXN0GjEuYXBpLnYxLm9yZy5VcGRhdGVDb2xsYWJvcmF0aW9uVmlzaWJpbGl0eVJlc3BvbnNlEkwKBlNlYXJjaBIdLmFwaS52MS5vcmcuU2VhcmNoT3Jnc1JlcXVlc3QaHi5hcGkudjEub3JnLlNlYXJjaE9yZ3NSZXNwb25zZSIDkAIBEl0KEEdldEZvbGxvd2luZ0luZm8SIy5hcGkudjEub3JnLkdldEZvbGxvd2luZ0luZm9SZXF1ZXN0GiQuYXBpLnYxLm9yZy5HZXRGb2xsb3dpbmdJbmZvUmVzcG9uc2USPwoGRm9sbG93EhkuYXBpLnYxLm9yZy5Gb2xsb3dSZXF1ZXN0GhouYXBpLnYxLm9yZy5Gb2xsb3dSZXNwb25zZRJFCghVbmZvbGxvdxIbLmFwaS52MS5vcmcuVW5mb2xsb3dSZXF1ZXN0GhwuYXBpLnYxLm9yZy5VbmZvbGxvd1Jlc3BvbnNlElQKDUxpc3RGb2xsb3dlcnMSIC5hcGkudjEub3JnLkxpc3RGb2xsb3dlcnNSZXF1ZXN0GiEuYXBpLnYxLm9yZy5MaXN0Rm9sbG93ZXJzUmVzcG9uc2USTAoOTGlzdENhdGVnb3JpZXMSFi5nb29nbGUucHJvdG9idWYuRW1wdHkaIi5hcGkudjEub3JnLkxpc3RDYXRlZ29yaWVzUmVzcG9uc2USRQoLQ3JlYXRlSW1hZ2USHi5hcGkudjEub3JnLkNyZWF0ZUltYWdlUmVxdWVzdBoWLmdvb2dsZS5wcm90b2J1Zi5FbXB0eUKuAQoOY29tLmFwaS52MS5vcmdCD09yZ1NlcnZpY2VQcm90b1ABWkFnaXRodWIuY29tL2R3YXluZWxhdm9uL2xvY2FsLWNvbW11bml0eS1wbGF0Zm9ybS9hcGkvZ2VuL2dvL3YxL29yZ6ICA0FWT6oCCkFwaS5WMS5PcmfKAgpBcGlcVjFcT3Jn4gIWQXBpXFYxXE9yZ1xHUEJNZXRhZGF0YeoCDEFwaTo6VjE6Ok9yZ2IGcHJvdG8z", [file_google_protobuf_empty, file_v1_org_org_types, file_v1_org_org_requests]);

/**
 * ==================== ORGANIZATION MANAGEMENT ====================
 *
 * @generated from service api.v1.org.OrgService
 */
export const OrgService: GenService<{
  /**
   * Creates a new organization with basic information
   *
   * @generated from rpc api.v1.org.OrgService.Create
   */
  create: {
    methodKind: "unary";
    input: typeof CreateRequestSchema;
    output: typeof CreateResponseSchema;
  },
  /**
   * Updates an organization
   *
   * @generated from rpc api.v1.org.OrgService.Update
   */
  update: {
    methodKind: "unary";
    input: typeof UpdateRequestSchema;
    output: typeof UpdateResponseSchema;
  },
  /**
   * Deletes an organization
   *
   * @generated from rpc api.v1.org.OrgService.Delete
   */
  delete: {
    methodKind: "unary";
    input: typeof DeleteRequestSchema;
    output: typeof DeleteResponseSchema;
  },
  /**
   * Retrieves an organization by slug
   *
   * @generated from rpc api.v1.org.OrgService.Get
   */
  get: {
    methodKind: "unary";
    input: typeof GetRequestSchema;
    output: typeof GetResponseSchema;
  },
  /**
   * Retrieves an organization by ID
   *
   * @generated from rpc api.v1.org.OrgService.GetById
   */
  getById: {
    methodKind: "unary";
    input: typeof GetByIdRequestSchema;
    output: typeof GetByIdResponseSchema;
  },
  /**
   * Updates collaboration visibility for an organization collaborator
   *
   * @generated from rpc api.v1.org.OrgService.UpdateCollaborationVisibility
   */
  updateCollaborationVisibility: {
    methodKind: "unary";
    input: typeof UpdateCollaborationVisibilityRequestSchema;
    output: typeof UpdateCollaborationVisibilityResponseSchema;
  },
  /**
   * ==================== UNIFIED SEARCH ====================
   * Single search method supporting both community and beyond modes
   * Automatically includes both physical address and service area organizations
   *
   * @generated from rpc api.v1.org.OrgService.Search
   */
  search: {
    methodKind: "unary";
    input: typeof SearchOrgsRequestSchema;
    output: typeof SearchOrgsResponseSchema;
  },
  /**
   * Gets following info for an organization
   *
   * @generated from rpc api.v1.org.OrgService.GetFollowingInfo
   */
  getFollowingInfo: {
    methodKind: "unary";
    input: typeof GetFollowingInfoRequestSchema;
    output: typeof GetFollowingInfoResponseSchema;
  },
  /**
   * Follow an organization
   *
   * @generated from rpc api.v1.org.OrgService.Follow
   */
  follow: {
    methodKind: "unary";
    input: typeof FollowRequestSchema;
    output: typeof FollowResponseSchema;
  },
  /**
   * Unfollow an organization
   *
   * @generated from rpc api.v1.org.OrgService.Unfollow
   */
  unfollow: {
    methodKind: "unary";
    input: typeof UnfollowRequestSchema;
    output: typeof UnfollowResponseSchema;
  },
  /**
   * List followers of an organization
   *
   * @generated from rpc api.v1.org.OrgService.ListFollowers
   */
  listFollowers: {
    methodKind: "unary";
    input: typeof ListFollowersRequestSchema;
    output: typeof ListFollowersResponseSchema;
  },
  /**
   * Retrieves list of available organization types/categories
   *
   * @generated from rpc api.v1.org.OrgService.ListCategories
   */
  listCategories: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof ListCategoriesResponseSchema;
  },
  /**
   * CreateImage creates an image
   *
   * @generated from rpc api.v1.org.OrgService.CreateImage
   */
  createImage: {
    methodKind: "unary";
    input: typeof CreateImageRequestSchema;
    output: typeof EmptySchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_v1_org_org_service, 0);

